<template>
  <Modal :show.sync="show" :size="media == '' ? '' : 'lg'" :showClose="false" style="padding: 0.25rem !important;">
    <span v-if="allowClose" role="button" class="close float-end fs-4" @click.prevent="show = false">
      <span aria-hidden="true"><i class="fa fa-times"></i></span>
    </span>
    <div class="text-center">
      <h4 class="mb-1 text-dark">{{ modalTitle }}</h4>
      <div class="col-md-12 col-lg-12 col-sm-12">
        <div class="row">
          <div v-show="media" class="col-md-5 col-lg-5 col-sm-12">
            <NextUrl :media="media" @emailFound="email => (registrationEmail = email)" @modalTitle="title => (modalTitle = title)" />
          </div>
          <div v-if="media" class="col-md-7 col-lg-7 col-sm-12 p-3">
            <h4 class="text-secondary my-5">
              To have a look at "{{ media.title }}" please sign in or create an account
            </h4>
            <button id="login" data-test="login" class="btn btn-primary" style="padding: 8px 32px;" @click="navigate(signin_url)">
              {{ $t('network.auth.login') }}
            </button>
            <br /><br />
            <h5>
              {{ $t('new-to-resonance') }}
              <span class="text-primary fw-semibold" style="cursor: pointer;" @click="navigate(signup_url)">
                {{ $t('network.auth.signUp') }}
              </span>
            </h5>
          </div>
          <div v-else>
            <h4 class="login-modal-sub-heading">{{ $t('LoginModal.have-a-resonance-account') }}</h4>
            <a ref="buttonLogin" class="btn login-modal-button fw-bolder" @click="navigate(signin_url)">
              <i class="fas fa-sign-in"></i>
              {{ $t('network.auth.login') }}
            </a>
            <h4 class="login-modal-sub-heading mt-3">
              {{ $t('LoginModal.or-join-us-to-keep-exploring') }}
              <a @click="navigate(signup_url)">{{ $t('network.heading') }}</a>
              {{ $t('LoginModal.to-its-fullest') }}
            </h4>
            <a class="btn login-modal-button fw-bolder" @click="navigate(signup_url)">
              <i class="fas fa-user-plus"></i>
              {{ $t('network.auth.signUp') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script>
import queryString from 'query-string';
import NextUrl from '../../components/commons/Networks/NextUrl.vue';
import Modal from '../../components/commons/Modals/Modal.vue';
import { mapState } from 'vuex';

export default {
  components: {
    NextUrl,
    Modal,
  },
  data() {
    return {
      show: false,
      modalTitle: '',
      registrationEmail: '',
      media: '',
      allowClose: '',
    };
  },
  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    },
    /**
     * Returns the combined version of the oauth login URL
     */
    signin_url() {
      let query = queryString.stringify({
        client_id: process.env.VUE_APP_OAUTH_SERVER_ID,
        redirect_uri: process.env.VUE_APP_OAUTH_SERVER_REDIRECT_URI,
        response_type: 'code',
        email: this.registrationEmail,
      });

      return process.env.VUE_APP_OAUTH_SERVER_URI + '/oauth/authorize?' + query;
    },
    signup_url() {
      let query = queryString.stringify({
        client_id: process.env.VUE_APP_OAUTH_SERVER_ID,
        redirect_uri: process.env.VUE_APP_OAUTH_SERVER_REDIRECT_URI,
        response_type: 'code',
        register: 'true',
        email: this.registrationEmail,
      });

      return process.env.VUE_APP_OAUTH_SERVER_URI + '/oauth/authorize?' + query;
    },
    ...mapState({
      nextURL: state => state.auth.nextURL,
    }),
  },
  created() {
    this.$bus.on('sign-in-update-email', email => {
      this.form.user_name = email;
    });
    this.$bus.on('show-sign-in', this.showModal);
    this.$bus.on('hide-sign-in', () => (this.show = false));
    this.$bus.on('go-to-sign-in', this.loginAuth);
    this.$bus.on('go-to-sign-up', this.registerAuth);
  },
  methods: {
    hide() {
      this.show = false;
    },
    showModal(nextURL, title = this.$t('network.auth.signIntoYourAccount'), media = '', close = true) {
      if (nextURL) {
        this.$store.dispatch('setNextURL', nextURL);
      }
      this.media = media;
      this.modalTitle = title;
      this.show = true;
      this.allowClose = close;
    },
    // Store intended oauth url before we navigate to the sign in page.
    navigate(url) {
      // for cross origin navigation
      window.location.href = url;
    },
    loginAuth(nextURL) {
      if (nextURL) {
        const params = new URLSearchParams(decodeURIComponent(nextURL).split('?')[1]);
        this.registrationEmail = params.get('email');
        this.$store.dispatch('setNextURL', nextURL);
      }
      this.navigate(this.signin_url);
    },
    registerAuth(nextURL) {
      if (nextURL) {
        const params = new URLSearchParams(decodeURIComponent(nextURL).split('?')[1]);
        this.registrationEmail = params.get('email');
        this.$store.dispatch('setNextURL', nextURL);
      }
      this.navigate(this.signup_url);
    },
  },
};
</script>
<style>
.login-modal-sub-heading {
  text-align: center;
  font: normal normal normal 18px/32px Nunito;
  letter-spacing: 0px;
  color: #5c6d80;
  opacity: 1;
}
.login-modal-button {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 6px;
  opacity: 1;
  text-align: left;
  font: normal normal normal 14px/24px Nunito;
  letter-spacing: 0px;
  color: #5c6d80;
}
</style>
